<template>
  <div class="navbar-container">
    <van-nav-bar 
      :title="title" 
      left-text="返回" 
      left-arrow
      @click-left="returnHome"
    >
      <!-- <van-icon name="manager-o" slot="right" /> -->
    </van-nav-bar>
    <router-view :type="type" :text="text" />
  </div>
</template>

<script>
import { NavBar, Icon } from 'vant'

export default {
  name: 'NavBar',
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon
  },
  data() {
    return {
    }
  },
  computed: {
    title() {
      return this.$route.query.title
    },
    type() {
      return this.$route.query.type
    },
    text() {
      return this.$route.query.text
    }
  },
  methods: {
    returnHome() {
      // 回退到上一页
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less">
  .navbar-container {
    .van-nav-bar.van-hairline--bottom {
      z-index: 11!important;
      position: fixed;
      top: 0;
      width: 100%;
    }
  }
</style>